import {invalidateQueries, q} from "../../state";
import {
  Diagram,
  DiagramId,
  OwnerId,
  PresetDiagram,
  UpdateDiagram,
  DiagramEvidenceId,
  RecordDiagramEvidence,
  UpdateDiagramEvidence,
} from "platformed-client/types";
import {platformedClient} from "..";

export async function get(diagramId: DiagramId): Promise<Diagram> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/diagrams/{diagram_id}", {
    path: {diagram_id: diagramId},
  });
}

export async function update(diagramId: DiagramId, update: UpdateDiagram): Promise<string> {
  const res = await platformedClient.internalRequest("put", "/region/{region}/api/tprm/diagrams/{diagram_id}", {
    path: {diagram_id: diagramId},
    body: update,
  });
  await invalidateQueries([q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function importFromPreset(diagramId: DiagramId, preset: PresetDiagram): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/import_from_preset",
    {path: {diagram_id: diagramId}, body: preset},
  );
  await invalidateQueries([q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function relayout(diagramId: DiagramId): Promise<Diagram> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/relayout",
    {path: {diagram_id: diagramId}},
  );
  await invalidateQueries([q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function assign(diagramId: DiagramId, ownerId: OwnerId | null): Promise<string> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/diagrams/{diagram_id}/owner", {
    path: {diagram_id: diagramId},
    body: ownerId,
  });
  await invalidateQueries([q.tprm.engagementDiagrams.filter(), q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function updateName(diagramId: DiagramId, name: string): Promise<string> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/diagrams/{diagram_id}/name", {
    path: {diagram_id: diagramId},
    body: name,
  });
  await invalidateQueries([q.tprm.engagementDiagrams.filter(), q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function updateDescription(diagramId: DiagramId, description: string): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/description",
    {path: {diagram_id: diagramId}, body: description},
  );
  await invalidateQueries([q.tprm.engagementDiagrams.filter(), q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function updateSummary(diagramId: DiagramId, summary: string | null): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/summary",
    {path: {diagram_id: diagramId}, body: summary},
  );
  await invalidateQueries([q.tprm.engagementDiagrams.filter(), q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function updateLanesEnabled(diagramId: DiagramId, lanesEnabled: boolean): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/lanes_enabled",
    {path: {diagram_id: diagramId}, body: lanesEnabled},
  );
  await invalidateQueries([q.tprm.diagram.filter(diagramId)]);
  return res;
}

export async function delete_(diagramId: DiagramId): Promise<string> {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/diagrams/{diagram_id}", {
    path: {diagram_id: diagramId},
  });
  await invalidateQueries([q.tprm.engagementDiagrams.filter()]);
  return res;
}

export async function loadDiagramEvidence(ids: DiagramEvidenceId[]) {
  return await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/understanding-diagram-evidence/load",
    {body: ids},
  );
}

export async function listDiagramEvidence(diagramId: DiagramId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/diagrams/{diagram_id}/evidence", {
    path: {diagram_id: diagramId},
  });
}

export async function addDiagramEvidence(diagramId: DiagramId, evidence: RecordDiagramEvidence) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/evidence",
    {path: {diagram_id: diagramId}, body: evidence},
  );
  await invalidateQueries([q.tprm.diagramEvidence.filter(diagramId)]);
  return res;
}

export async function updateDiagramEvidence(
  diagramId: DiagramId,
  evidenceId: DiagramEvidenceId,
  update: UpdateDiagramEvidence,
) {
  const res = await platformedClient.internalRequest(
    "patch",
    "/region/{region}/api/tprm/diagrams/{diagram_id}/evidence/{diagram_evidence_id}",
    {path: {diagram_id: diagramId, diagram_evidence_id: evidenceId}, body: update},
  );
  await invalidateQueries([q.tprm.diagramEvidence.filter(diagramId), q.tprm.diagramEvidenceById.filter(evidenceId)]);
  return res;
}
